import { Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { validationSchema } from '../constants/validationSchema';
import * as yup from 'yup';
import { Grid, IconButton } from '@mui/material';
import { TextFieldWrapper } from '.';
import { Close, Reply } from '@mui/icons-material';
import useNotification from '../hooks/useNotification';
import { ApiManager } from '../services/api';
import { useSearchParams } from 'react-router-dom';

function ChatingComponent({}) {
  const [searchParams] = useSearchParams();
  const tenderId = searchParams.get('tender');
  const srid = searchParams.get('srid');
  const { user, role } = useSelector(({ user }) => user);
  const [messages, setMessages] = useState([]);
  const [receivers, setReceivers] = useState([]);
  const [selectedMessage, setSelectedMessage] = useState();
  const [tender, setTender] = useState();
  const { successNonification, errorNonification } = useNotification();

  useEffect(() => {
    if (Array.isArray(messages) && messages.length > 0) {
      var tempReceivers = [];
      messages.forEach((item, index) => {
        if (index === 0) {
          setTender(item?.tender);
        }
        if (
          item?.sender?._id !== user?._id &&
          tempReceivers.indexOf(item?.sender?._id) == -1
        ) {
          tempReceivers.push(item?.sender?._id);
        }
        if (Array.isArray(item?.receivers))
          item?.receivers.forEach((_item, _index) => {
            if (
              _item._id !== user?._id &&
              tempReceivers.indexOf(_item._id) == -1
            ) {
              tempReceivers.push(_item._id);
            }
          });
      });
      setReceivers(tempReceivers);
    } else {
      setTender();
      setSelectedMessage();
      setReceivers([]);
    }
  }, [messages]);

  const getChatFor = async () => {
    const data = {
      /* bid: bid, */
      tender: tenderId,
      srid: srid,
    };
    const res = await ApiManager.getChatFor(data);
    if (res?.status === 200 && res?.data?.result) {
      setMessages(res?.data?.result);
    } else {
      setMessages([]);
    }
  };

  useEffect(() => {
    if ((srid, tenderId)) {
      getChatFor();

      const interval = setInterval(() => {
        getChatFor();
      }, 30000);

      return () => clearInterval(interval);
    }
  }, [tenderId, srid]);

  return (
    <div className="w-full flex flex-col justify-between overflow-y-auto flex flex-col overflow-y-auto h-full">
      <div className="px-5 py-5 flex justify-between items-center bg-white border-b-2">
        <div className="font-semibold text-2xl">
          {tender?.tenderTitle || 'Chating...'}
        </div>
      </div>
      <div className="flex-1 flex flex-col mt-5 overflow-y-auto">
        {Array.isArray(messages) &&
          messages?.map((message, index) => {
            if (message?.sender?._id === user?._id) {
              return (
                <div key={message?._id} className="flex justify-end mb-4">
                  <div className="flex flex-col items-center justify-center">
                    <IconButton
                      onClick={() => setSelectedMessage(message)}
                      size="small"
                    >
                      <Reply fontSize="small" />
                    </IconButton>
                  </div>
                  <div className="overflow-hidden mr-2 bg-blue-400 rounded-bl-3xl rounded-tl-3xl rounded-tr-xl text-white text-xs">
                    {message?.replyTo && (
                      <div className="py-3 px-4 bg-blue-300">
                        {message?.replyTo?.message}
                      </div>
                    )}
                    {message?.title && (
                      <div className="py-1 px-4 font-bold">
                        {message?.title}
                      </div>
                    )}
                    <div className="py-1 px-4">{message?.message}</div>
                  </div>
                </div>
              );
            }
            return (
              <div key={message?._id} className="flex justify-start mb-4">
                <div>
                  <div className="ml-2 text-[9px]">{message?.sender?.name}</div>
                  <div className="ml-2 bg-gray-400 rounded-br-3xl rounded-tr-3xl rounded-tl-xl text-white text-xs">
                    {message?.replyTo && (
                      <div className="py-3 px-4 bg-gray-300">
                        {message?.replyTo?.message}
                      </div>
                    )}
                    {message?.title && (
                      <div className="py-1 px-4 font-bold">
                        {message?.title}
                      </div>
                    )}
                    <div className="py-1 px-4">{message?.message}</div>
                  </div>
                </div>
                <div className="flex flex-col items-center justify-center">
                  <IconButton
                    onClick={() => setSelectedMessage(message)}
                    size="small"
                  >
                    <Reply fontSize="small" />
                  </IconButton>
                </div>
              </div>
            );
          })}
      </div>
      {tenderId || srid ? (
        <div className="py-5  px-5">
          <Formik
            initialValues={{
              title: '',
              message: '',
            }}
            validationSchema={yup.object().shape({
              message: validationSchema.required('Message'),
            })}
            onSubmit={async (values, actions) => {
              try {
                const data = new FormData();
                data.append('title', values?.title || '');
                data.append('message', values?.message || '');
                if (selectedMessage) {
                  var _receivers = [];
                  if (selectedMessage.sender._id !== user._id) {
                    _receivers.push(selectedMessage.sender._id);
                  }
                  selectedMessage?.receivers?.map((item, index) => {
                    if (item._id !== user._id) {
                      _receivers.push(item._id);
                    }
                  });
                  //  data.append('bid', selectedMessage?.bid?._id);
                  data.append('tender', selectedMessage?.tender?._id);
                  data.append('replyTo', selectedMessage?._id);
                  _receivers.map((item, index) => {
                    data.append(`receivers[${index}]`, item);
                  });
                } else {
                  data.append('tender', tender?._id);
                  //data.append('bid', bidId);
                  receivers?.map((item, index) => {
                    data.append(`receivers[${index}]`, item);
                  });
                }

                const res = await ApiManager.sendMessage(data);
                if (res?.status === 200) {
                  successNonification('Message sent');
                  getChatFor();
                  actions.resetForm();
                  setSelectedMessage();
                } else {
                  errorNonification(
                    res?.data?.message || 'Something went wrong.'
                  );
                }
              } catch (error) {
                console.log(error);
              }
            }}
          >
            {({
              values,
              touched,
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
            }) => (
              <Grid container spacing={1}>
                {selectedMessage && (
                  <Grid item xs={12}>
                    <div className="flex justify-between items-center  gap-2 bg-gray-200 rounded-tr-2xl rounded-tl-2xl">
                      <div className="text-xs flex-1 pl-2">
                        {selectedMessage?.message}
                      </div>
                      <div>
                        <div className="flex flex-col items-center justify-center">
                          <IconButton
                            onClick={() => setSelectedMessage()}
                            size="small"
                          >
                            <Close fontSize="small" />
                          </IconButton>
                        </div>
                      </div>
                    </div>
                  </Grid>
                )}
                <Grid item xs={12}>
                  <div className="flex flex-col gap-2">
                    <TextFieldWrapper
                      placeholder="title"
                      autoFocus
                      name="title"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.title}
                      helperText={touched.title && errors.title}
                      error={!!touched.title && !!errors.title}
                    />
                  </div>
                </Grid>
                <Grid item xs={12}>
                  <div className="flex flex-col gap-2">
                    <TextFieldWrapper
                      placeholder="Message *"
                      multiline
                      minRows={2}
                      maxRows={3}
                      name="message"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.message}
                      helperText={touched.message && errors.message}
                      error={!!touched.message && !!errors.message}
                    />
                  </div>
                </Grid>
                <Grid item xs={12}>
                  <div className="flex items-center justify-end">
                    <button
                      onClick={handleSubmit}
                      className="text-xs bg-main text-white text-center px-4 py-1 rounded-full font-bold flex items-center justify-center gap-1 cursor-pointer"
                    >
                      Send
                    </button>
                  </div>
                </Grid>
              </Grid>
            )}
          </Formik>
        </div>
      ) : (
        <div className="py-5 flex justify-center bg-yellow-100">
          <div className="font-bold text-sm text-gray-400">
            Select user to chat with buyer
          </div>
        </div>
      )}
    </div>
  );
}

export default ChatingComponent;
